import { render, staticRenderFns } from "./ChatDueToolTip.vue?vue&type=template&id=b7c80d48&scoped=true&"
import script from "./ChatDueToolTip.vue?vue&type=script&lang=js&"
export * from "./ChatDueToolTip.vue?vue&type=script&lang=js&"
import style0 from "./ChatDueToolTip.vue?vue&type=style&index=0&id=b7c80d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c80d48",
  null
  
)

export default component.exports